import {Draggable, gsap, InertiaPlugin, Flip} from "gsap/all";
import $ from "jquery";
import {BaseGameBBAI} from "../base/BaseGameBBAI";
import {AIControlMainAppScreenTransition} from "./AIControlMainAppScreenTransition";
import {Khronos} from "./components/Khronos";
import {Hydra} from "./components/Hydra";
import {Marquee} from "./components/Marquee";
import {Weather} from "./components/Weather";
import {Maestro} from "./components/Maestro";
import {Concerto} from "./components/Concerto";
import {Occam} from "./components/Occam";
import {Hercules} from "./components/Hercules";
import {Compass} from "./components/Compass";
import {Shoto} from "./components/Shoto";
import {Evergreen} from "./components/Evergreen";
import {Aquilon} from "./components/Aquilon";
import {Tsar} from "./components/Tsar";
import {Triton} from "./components/Triton";
import {Sirocco} from "./components/Sirocco";
import {BlurryLettersAnimation} from "../base/BlurryLettersAnimation";

// Constructor
export class AIControlMainApp extends BaseGameBBAI {
  // debugAlgo = "maestro";

  constructor() {
    super(`data/ai-control-main.json`, 'ai-control');
    gsap.registerPlugin(Draggable, InertiaPlugin, Flip);
    this.screenTransition = new AIControlMainAppScreenTransition();

    this.listenForRFID = false;
    this.rfidActive = false;
    this.rfidPending = null;
    this.currentRFID = null;

    this.rfidRemovedTimeout = null;

    this.isIdle = false;
    this.algorithms = {}

    this.weather = null;
  }

  initGame() {
    super.initGame();

    // Audio example
    // setInterval(() => app.audio.play("audio/click.wav", 1, true), 1000)

    // Create an array of all the algorithms here as we have the data loaded correctly at this point
    this.algorithms = {
      khronos: new Khronos("khronos"),
      maestro: new Maestro("maestro"),
      concerto: new Concerto("concerto"),
      occam: new Occam("occam"),
      hercules: new Hercules("hercules"),
      compass: new Compass("compass"),
      shoto: new Shoto("shoto"),
      evergreen: new Evergreen("evergreen"),
      tsar: new Tsar("tsar"),
      aquilon: new Aquilon("aquilon"),
      hydra: new Hydra("hydra"),
      triton: new Triton("triton"),
      sirocco: new Sirocco("sirocco"),
    }

    // Weather bar
    this.weather = new Weather(true);

    // First screen blurry letters
    this.blurryLettersAnim = new BlurryLettersAnimation(`#screen-1 .screen-content .title .${this.i18n.lang}`);

    // Status bar
    this.statusBar = new Marquee({
      container: "#status-bar",
      track: ".status-bar",
      itemSelector: ".status-static-element",
      speed: 20
    });
    this.statusBar.init();

    // Highlight algorithms for current visitor
    this.data.cms_content.visitor_customization.highlighted_algorithms.forEach(algorithm => {
      $(`.algorithms-selectors-container .algorithm.view-mode-teaser[data-algorithm-machine-name="${algorithm.machine_name}"]`).addClass("highlighted");
    });

    this.initEvents();

    this.setPreferredUnit();

    this.applyCharactersConversion();

    return this.initAlgos();

    // Debug to skip to algo selection
    // Debug: skip directly to algorithm selection
/*    return this.initAlgos().then(() => {
      this.goToScreen(2);

      this.screenTransition.screenTransitionTimeline.progress(1);
    });*/

    // Debug to skip to specific algo
/*    return this.initAlgos().then(() => {
      if (this.debugAlgo && this.algorithms[this.debugAlgo]) {
        console.log(`Debug: Skipping to ${this.debugAlgo}`);
        this.algorithms[this.debugAlgo].start();
        this.goToScreen(`3-${this.debugAlgo}`, () => {
          this.algorithms[this.debugAlgo].onTransitionEnded();
        });
      }
    });*/
  }

  async initAlgos() {
    for (const [name, algorithm] of Object.entries(this.algorithms)) {
      await algorithm.init();
    }
  }

  initEvents() {
    // Debugging trigger rfid scans with key presses
    $(window).keypress((e) => {
      const keysMap = {
        "=": {
          id: null,
          state: "off"
        },
        1: {
          id: "khronos",
          state: "on"
        },
        2: {
          id: "maestro",
          state: "on"
        },
        3: {
          id: "concerto",
          state: "on"
        },
        4: {
          id: "occam",
          state: "on"
        },
        5: {
          id: "hercules",
          state: "on"
        },
        6: {
          id: "compass",
          state: "on"
        },
        7: {
          id: "shoto",
          state: "on"
        },
        8: {
          id: "evergreen",
          state: "on"
        },
        9: {
          id: "tsar",
          state: "on"
        },
        0: {
          id: "aquilon",
          state: "on"
        },
        "-": {
          id: "hydra",
          state: "on"
        },
        q: {
          id: "triton",
          state: "on"
        },
        w: {
          id: "sirocco",
          state: "on"
        }
      }

      if (Object.hasOwn(keysMap, e.key)) {
        this.rfidTriggered(keysMap[e.key].id, keysMap[e.key].state);
      }
    })

    this.initAlgoListing();
  }

  initAlgoListing() {
    const $listingContainer = $(".algorithms-selectors-container");
    const $buttons = $listingContainer.find(".filters .filter-button");

    $buttons.off("click").on("click", (e) => {
      app.audio.play("audio/ButtonOnClick_260423.wav", 1, true)

      const $el = $(e.currentTarget);
      const type = $el.data("building-type");

      // Skip if already active
      if ($el.is(".active")) return;

      $buttons.removeClass("active");
      $el.addClass("active");

      this.applyAlgoFilter(type);
    });
  }

  /**
   * Apply the algorithm filter
   * @param type
   */
  applyAlgoFilter(type) {
    const $listingContainer = $(".algorithms-selectors-container");
    const $listing = $listingContainer.find(".listing");
    const $algos = $listingContainer.find(".algorithm.view-mode-teaser");

    if (this.gridAnimation) this.gridAnimation.kill();

    const state = Flip.getState($algos);

    $algos.each((_, el) => {
      const types = $(el).data("algorithm-building-types").split(",");
      const shouldShow = type === "all" || types.includes(type);
      $(el).toggleClass("hidden", !shouldShow);
    });

    // Calculate destination height before animating
    gsap.set($listing, {minHeight: "auto"});
    const finalHeight = $listing.outerHeight();

    // Set the container to start height and then animate to final height
    gsap.set($listing, {minHeight: $listing.outerHeight()});

    this.gridAnimation = Flip.from(state, {
      duration: 0.4,
      ease: "power2.out",
      absolute: true,
      onStart: () => {
        gsap.to($listing, {
          minHeight: finalHeight,
          duration: 0.4,
          ease: "power2.out"
        });
      },
      onComplete: () => {
        this.gridAnimation = null;
      }
    });
  }

  /**
   * Refresh the algorithm listing
   * @param {null} [forceType] - Optional type to force (e.g., 'all')
   */
  refreshAlgoListing(forceType = null) {
    const $listingContainer = $(".algorithms-selectors-container");
    const $buttons = $listingContainer.find(".filters .filter-button");
    const $algos = $listingContainer.find(".algorithm.view-mode-teaser");

    // Force a specific filter
    let type = forceType || ($buttons.filter(".active").data("building-type") || "all");
    if (forceType) {
      $buttons.removeClass("active");
      $buttons.filter(`[data-building-type="${forceType}"]`).addClass("active");
    }

    // Filter change must be delayed,
    // Because the calculation are wrong since the opening/close of algo is animated
    $algos.removeClass("filtered-out selected active");
    setTimeout(() => {
      this.applyAlgoFilter(type);
    }, 750);
  }

  startGame() {
    if (this.starting) return;
    this.starting = true;

    app.audio.play("audio/ButtonOnPress_260423.wav", 1, true)

    setTimeout(() => {
      this.sendScreenBridgeMessage("/send active");
      this.goToScreen(2);
      this.starting = false;
    }, 750);
  }

  initScreen(screenId) {
    const targetScreenNoSuffix = parseInt(screenId.toString().split("-")[0]);

    // Reset algorithm listing grid
    // When going from listing to an algorithm
    if (this.currentScreen === 2 && targetScreenNoSuffix >= 3) {
      this.refreshAlgoListing("all");
    }

    // Clear pending rfid when going to screen 3
    if (targetScreenNoSuffix >= 3) {
      this.rfidPending = null
    }

    // Start/stop initial screen blurry animation
    if (screenId === 1) this.blurryLettersAnim.play();
    else this.blurryLettersAnim.stop();
  }

  goToScreen(screenId, callback = null, skipLockScreenCheck = false, options = {}) {
    // If we are currently idle, allow the re-animation
    if (this.isIdle) {
      options.allowSameScreenTransition = true;
    }

    // Get screen id without the algorith suffix
    const currentScreenNoSuffix = parseInt(this.currentScreen.toString().split("-")[0]);
    const targetScreenNoSuffix = parseInt(screenId.toString().split("-")[0]);

    // When going back to intro or going to any algorithm
    if (targetScreenNoSuffix <= 2 || (this.currentScreen <= 2 && targetScreenNoSuffix === 3)) {
      // Lock RFID when heading to intro or when first entering algorithms
      this.listenForRFID = false;
    }

    // Kill RFID timeout when going back to algorithm list
    if (targetScreenNoSuffix < 3) this.stopRfidRemovedTimeout();

    // Screen skip in/out transition, if currentTransitionString is listed in exceptions array
    const currentTransitionString = `${currentScreenNoSuffix}->${targetScreenNoSuffix}`;
    if (["1->2", "2->3", "3->3", "3->2"].includes(currentTransitionString)) {
      options.skipOut = true;
      options.skipIn = targetScreenNoSuffix >= 3;
    }

    // Send gotoScreen to screenbridge early
    if (["2->3"].includes(currentTransitionString)) {
      this.sendScreenBridgeMessage(`gotoScreen ${screenId}`);
    }

    // Make sure screen 2 video is playing
    if (["1->2", "3->1"].includes(currentTransitionString)) {
      this.replayVideo(".main-background");
    }

    // Execute Transition
    this.screenTransition.transition(this.currentScreen, screenId, callback,
      (combinedCallback) => {
        this.isIdle = false;

        // Call parent logic; if successful, notify bridge
        if (super.goToScreen(screenId, combinedCallback, skipLockScreenCheck, options)) {
          if (!["2->3"].includes(currentTransitionString)) {
            this.sendScreenBridgeMessage(`gotoScreen ${screenId}`);
          }
        }
      }, {
        ...options,
        // Screen 3+, use the same in/out animations
        logicalFromId: currentScreenNoSuffix,
        logicalToId: targetScreenNoSuffix,
        onComplete: () => {
          // Unlock RFID when transition is fully complete
          if (targetScreenNoSuffix >= 2) {
            this.listenForRFID = true;
            this.checkForPendingRfid();
          }
        }
      }
    );
  }

  goToNextScreen(callback) {
    this.goToScreen(parseInt(this.currentScreen) + 1, callback);
  };

  goToPreviousScreen(callback) {
    const $screenIdDestination = parseInt(this.currentScreen) - 1;
    if ($screenIdDestination === 1) {
      this.reset(1);
    } else {
      this.goToScreen($screenIdDestination, callback);
    }
  };

  // Can be overridden in child classes
  onScreenBridgeMessage(messageString) {
    super.onScreenBridgeMessage(messageString);
    // console.log(messageString);

    if (messageString.startsWith("/rfid")) {
      const messageData = messageString.replace("/rfid ", "");
      const rfidID = messageData.split("/")[0];
      const rfidState = messageData.split("/")[1];

      this.rfidTriggered(rfidID, rfidState);
    }
  }

  rfidTriggered(id, state) {
    console.log("RFID Triggered: " + id, state);
    const currentScreenNoSuffix = parseInt(this.currentScreen.toString().split("-")[0]);
    const currentAlgo = (currentScreenNoSuffix === 3) ? this.currentScreen.toString().split("-")[1] : null;
    const targetScreenNoSuffix = (id !== null) ? `3-${id}` : 2;

    if (!this.listenForRFID) {
      // We are not listening for a RFID scan at this point so ignore
      if (this.currentScreen !== 1) {
        console.log("Not ready for RFID. Marking as pending and skipping.")
        this.rfidPending = (state === "on") ? id : "off";
      } else {
        console.log("Not ready for RFID, ignoring")
      }
      return;
    }

    this.rfidActive = state === "on";
    this.currentRFID = this.rfidActive ? id : null;

    // Prevent same algo detection
    if (currentScreenNoSuffix === 3 && currentAlgo === id && this.rfidActive) {
      return;
    }

    // Find the screen that contains the algorithm we need

    if (this.rfidActive && this.currentRFID && targetScreenNoSuffix) {

      // We are alrady on screen 3, stop current algo before going to the new one
      if (currentScreenNoSuffix === 3) {
        this.stopRfidRemovedTimeout();
        this.algorithms[currentAlgo].stop();
      }

      // Init algorithms graphs and go to screen
      const savedTargetRFID = this.currentRFID
      this.algorithms[savedTargetRFID].start();
      this.goToScreen(targetScreenNoSuffix, () => {
        if (currentAlgo) {
          this.algorithms[currentAlgo].reset();
        }
        this.algorithms[savedTargetRFID].onTransitionEnded();
      });
    } else if (currentScreenNoSuffix === 3) {
      if (!this.isIdle) {
        // Lock RFID listening while the animation plays
        this.listenForRFID = false;
        this.isIdle = true;

        this.algorithms[currentAlgo].stop();

        // Play idle transition
        this.screenTransition.playIdle(() => {
          if (currentAlgo) {
            console.log("will reset algo", currentAlgo)
            this.algorithms[currentAlgo].reset();
          }

          this.listenForRFID = true;
          this.checkForPendingRfid();
        });

        this.startRfidRemovedTimeout();
      }
    }
  }

  /**
   * Returns all algorithm instances whose `isActive` flag is set.
   */
  getCurrentAlgorithm() {
    return Object.values(this.algorithms).find(algo => algo.isActive);
  }

  startRfidRemovedTimeout() {
    this.stopRfidRemovedTimeout();

    this.rfidRemovedTimeout = setTimeout(() => {
      this.goToScreen(2);
    }, this.rfidRemovedDelay * 1000)
  }

  stopRfidRemovedTimeout() {
    if (this.rfidRemovedTimeout !== null) {
      clearTimeout(this.rfidRemovedTimeout);
      this.rfidRemovedTimeout = null;
    }
  }

  checkForPendingRfid() {
    console.log("checkForPendingRfid:", this.rfidPending);
    if (this.rfidPending !== null) {
      if (this.rfidPending === "off") this.rfidTriggered(null, "off");
      else this.rfidTriggered(this.rfidPending, "on");
      this.rfidPending = null;
    }
  }

  getAlgorithmsByBuildingType(type) {
    const $elements = $('.algorithms-selectors-container .algorithm.view-mode-teaser[data-algorithm-building-types]');

    if (type === 'all') return $elements;

    return $elements.filter(function () {
      const types = $(this).data('algorithm-building-types').split(',');
      return types.includes(type);
    });
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   */
  reset(screenId) {

    // Reset redirect timeout
    if (this.redirectTimeout !== false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    // Disable RFID
    this.stopRfidRemovedTimeout();
    this.listenForRFID = false;
    this.rfidActive = false;
    this.rfidPending = null;
    this.currentRFID = null;

    this.isIdle = false;

    // Stop any running algorithm
    for (const [name, algorithm] of Object.entries(this.algorithms)) {
      algorithm.stop();
      algorithm.reset();
    }

    // Reset variable and timeline
    this.killTimeline(this.currentTimeline);
    this.screenTransition.reset();
    this.blurryLettersAnim.reset();

    this.replayVideo("#screen-1 .screen-background");

    const resetCallback = () => {
      // Things that reset after goToScreen
      this.sendScreenBridgeMessage("/send idle");
      this.starting = false;

      // Reset algorithm listing grid
      this.refreshAlgoListing("all");
    }

    // Super
    return super.reset(screenId, resetCallback);
  }

}
